<template>
    <tr class="ticket-row" :class="statusClass">
        <td>
            {{ registrationCategory.date | dateFormat(registrationCategory.timezone || 'Europe/London', 'Do MMM YYYY HH:mm') }}
        </td>
        <td>
            <strong>{{ registrationCategory.name }}</strong>
        </td>
        <td class="text-center">
           {{ registrationCategory.current_price.amount | money(registrationCategory.current_price.currency) }}
        </td>
        <td class="text-right">
            <plus-minus-control
                class="float-right"
                style="display:inline-block"
                :value="value"
                @input="$emit('input', $event)"
                :disabled="disabled"
                :max="ParseInt(registrationCategory.pre_pay_setting.data.max_pre_pay_quantity)"
                :min="minQuantity"
            ></plus-minus-control>
        </td>
    </tr>
</template>

<script>
import PlusMinusControl from '../../../AAA_TO_REFACTOR/PlusMinsControl.vue';
import {dateFormat} from "../../../Utility/filters/dates";
import {money} from "../../../Utility/filters/money";
import ParseInt from "lodash-es/parseInt";

export default {
    name: "BulkRow",
    components: {
        PlusMinusControl,
    },
    filters: {
        dateFormat,
        money
    },
    props: {
        registrationCategory: {
            type: Object,
            required: true,
            default: () => ({})
        },
        value: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        },
        topUpBulkAction: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        minQuantity() {
            if (this.topUpBulkAction) {
                return 1;
            }
            return parseInt(this.registrationCategory.pre_pay_setting.data.min_pre_pay_quantity);
        },
        statusClass() {
            let classes = [];

            if (!this.registrationCategory.human_status) {
                classes.push('open');
            } else {
                switch (this.registrationCategory.human_status) {
                    case 'human_status_open':
                        classes.push('open');
                        break;

                    case 'human_status_closed':
                    case 'human_status_full':
                        classes.push('closed');
                        break;

                    case 'human_status_waiting_list':
                        classes.push('waiting-list');
                        break;

                    default:
                        classes.push('open');
                }
            }

            if (this.value > 0) {
                classes.push('table-active');
            }

            return classes.join(' ');
        }
    },
    methods: {
        ParseInt
    }
}
</script>

<style scoped lang="scss">
$open: #6fa551;
$closed: #dc143c;
$waitingList: #ecb618;

td {
    font-size: 1rem;
    border: none;
    border-right: 1px solid #e8e8e8;
    vertical-align: middle;
    padding: 1.25rem 1.25rem;
}

td:last-child {
    border-right: none;
}

tr {
    &.ticket-row {
        border-bottom: 1px solid #e8e8e8 !important;
    }

    &.open {
        box-shadow: inset 4px 0 0 $open;
    }

    &.closed {
        box-shadow: inset 4px 0 0 $closed;
    }

    &.waiting-list {
        box-shadow: inset 4px 0 0 $waitingList;
    }

    &.table-active {
        background-color: #e7f3ff !important;
    }
}

.badge-lg {
    font-size: 0.95rem;
    padding: 0.4rem 0.7rem;
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/RegistrationCategories/Tickets/Table/BulkRow.vue